import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {

  const runTimeConfig = useRuntimeConfig();
  const route = useRoute();
  // Only run in production
  if (runTimeConfig.public.clientBaseUrl !== 'https://topauto.tn')
    return;
  // Keep third-party ads scripts away from credential-sensitive routes.
  if (
    route.path.startsWith('/authentication') ||
    route.path.includes('/dashboard/parameter/mot_de_pass')
  ) {
    return;
  }

  const trackingId = 'AW-17692629445'

  // Inject Google Ads script
  const gtagScript = document.createElement('script')
  gtagScript.setAttribute('async', '')
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
  document.head.appendChild(gtagScript)

  // Inject inline config script
  const inlineScript = document.createElement('script')
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${trackingId}');
  `
  document.head.appendChild(inlineScript)
})
